const config = {
    /* Your Superchat application key */
    applicationKey: null
};

/**
 * Get Superchat instance from window
 * @return {Function|undefined} Superchat function or undefined if not loaded
 */
function getSuperchat() {
    return window.Superchat;
}

/**
 * Superchat analytics plugin
 * @link https://developers.superchat.com/docs/widget-sdk
 * @param {object}  pluginConfig - Plugin settings
 * @param {string}  pluginConfig.applicationKey - Your Superchat application key
 * @return {object} Analytics plugin
 * @example
 *
 * superchatPlugin({
 *   applicationKey: 'your-application-key'
 * })
 */
function superchatPlugin(pluginConfig = {}) {
    return {
        name: 'superchat',
        config: {
            ...config,
            ...pluginConfig
        },
        methods: {
            show() {
                const superchat = getSuperchat();
                if (typeof superchat === 'undefined') return;
                superchat.show();
            },
            hide() {
                const superchat = getSuperchat();
                if (typeof superchat === 'undefined') return;
                superchat.hide();
            },
            open(options) {
                const superchat = getSuperchat();
                if (typeof superchat === 'undefined') return;
                superchat.open(options);
            }
        },
        /* Load Superchat widget on page */
        initialize: ({ config }) => {
            const { applicationKey } = config;
            if (!applicationKey) {
                throw new Error('No Superchat applicationKey provided');
            }

            if (!document.getElementById('superchatScript')) {
                const superchatScript = document.createElement('script');
                superchatScript.id = 'superchatScript';
                superchatScript.src = 'https://widget.superchat.de/sdk.js';
                superchatScript.defer = true;
                superchatScript.onload = () => {
                    const superchat = getSuperchat();
                    if (superchat) {
                        superchat.init({
                            applicationKey: applicationKey
                        });
                    }
                };
                document.body.appendChild(superchatScript);
            } else {
                const superchat = getSuperchat();
                if (superchat) {
                    superchat.init({
                        applicationKey: applicationKey
                    });
                }
            }
        },
        /* Not supported by Superchat SDK */
        page: () => null,
        /* Not supported by Superchat SDK */
        track: () => null,
        /* Remove Superchat on analytics.reset */
        reset: () => {
            const superchat = getSuperchat();
            if (typeof superchat === 'undefined') return;
            superchat.hide();
        },
        /* Check if Superchat loaded */
        loaded: () => {
            return getSuperchat();
        }
    };
}

export default superchatPlugin;
